import { UserRoles } from 'src/enums'

interface RoleLike {
  name?: string
}

interface UserContractorLike {
  role?: RoleLike
}

export const isViewOnlyRole = (role?: RoleLike): boolean => role?.name === UserRoles.GeneralContractor

export const isViewOnlyUser = (userContractors?: UserContractorLike[] | null, fallbackRole?: RoleLike): boolean => {
  if (userContractors && userContractors.length > 0) {
    return userContractors.every((uc) => isViewOnlyRole(uc.role))
  }

  return isViewOnlyRole(fallbackRole)
}
